/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { equals as i } from "../../core/arrayUtils.js";
import { ObjectStack as n } from "../../core/ObjectStack.js";
import { g as r, f as o, c as t, n as c, d as e, b as s, a as u } from "../../chunks/vec3.js";
import { a, c as g } from "../../chunks/vec3f64.js";
import { sv3d as f } from "./vectorStacks.js";

function d(i) {
  return i ? {
    origin: a(i.origin),
    direction: a(i.direction)
  } : {
    origin: g(),
    direction: g()
  };
}

function m(n, r) {
  return i(n.origin, r.origin) && i(n.direction, r.direction);
}

function j(i, n) {
  var r = S.get();
  return r.origin = i, r.direction = n, r;
}

function l(i) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : d();
  return k(i.origin, i.direction, n);
}

function p(i, n) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : d();
  return r(t.origin, i), o(t.direction, n, i), t;
}

function k(i, n) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : d();
  return r(o.origin, i), r(o.direction, n), o;
}

function h(i, n) {
  var r = t(f.get(), c(f.get(), i.direction), o(f.get(), n, i.origin));
  return e(r, r);
}

function v(i, n) {
  return Math.sqrt(h(i, n));
}

function b(i, n, r) {
  var t = e(i.direction, o(r, n, i.origin));
  return s(r, i.origin, u(r, i.direction, t)), r;
}

function q() {
  return {
    origin: null,
    direction: null
  };
}

var S = new n(q);
export { b as closestPoint, l as copy, d as create, v as distance, h as distance2, m as equals, p as fromPoints, k as fromValues, j as wrap };